module.exports = __webpack_public_path__ + "static/homeBG.8b92bf8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeBG.jpg
// module id = 839
// module chunks = 35783957827783